module.exports = __webpack_public_path__ + "static/11-f19f89231e6bc108dc3aaa991ba6c079.jpg";